module.exports = __webpack_public_path__ + "img/h1.8074ea3a.png";